const API_URL = `${process.env.REACT_APP_API_URL}/auth`;

export const login = async (credenciales) => {
  const res = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credenciales)
  });
  return await res.json();
};

export const register = async (datosUsuario) => {
  const res = await fetch(`${API_URL}/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datosUsuario)
  });
  return await res.json();
};
